import React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ReactComponent as CouponIcon } from "@assets/icons/coupon.svg";
import { Button } from "@mui/material";
import TextView from "../TextView";

const Container = styled.div`
  width: 100%;
  min-height: 76px;
  border-radius: 8px;
  border: 1px solid #ec8e4e;
  background: #fff0de;
  display: flex;
  align-items: stretch;
  gap: 15px;
  padding-right: 16px;
`;

const IconWrapper = styled.div`
  background-color: #ec8e4e;
  width: 80px;
  min-width: 80px;
  align-self: stretch;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-right: 1px dashed #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  padding: 10px;
`;

const CouponDisplay = () => {
  const couponCode = "50ANNUAL";

  const handleCopyCode = () => {
    navigator.clipboard.writeText(couponCode);
    toast.success("Coupon Copied!");
  };

  return (
    <Container>
      <IconWrapper>
        <CouponIcon width="40px" height="30px" />
      </IconWrapper>
      <TextContent>
        <TextView variant="subtitle" style={{ fontWeight: 700 }}>
          Limited-Time Offer 🎉
        </TextView>
        <TextView variant="text">
        Choose an annual plan and enjoy 50% off your first year with iYuga — our way of welcoming you in.
        </TextView>
      </TextContent>
      {/* <Button
        sx={{
          width: "auto",
          alignSelf: "center",
          backgroundColor: "#9B5AF8",
          color: "#fff",
          textDecoration: "capitalize",

          "&:hover": {
            backgroundColor: "#9B5AF8",
          },
        }}
        onClick={handleCopyCode}
      >
        Copy Code
      </Button> */}
    </Container>
  );
};

export default CouponDisplay;
